<template>
  <div class="step-layout">
    <StepIndicator :current-step="currentStep" :total-steps="totalSteps" />

    <div v-if="showBackLink || $slots.skip" class="step-layout__back-skip-wrapper">
      <BackLink v-if="showBackLink" @click="handleBack" />
      <slot name="skip" />
    </div>

    <h2 class="step-layout__title">{{ title }}</h2>

    <div class="step-layout__content">
      <slot />
    </div>

    <div v-if="$slots.footer" class="step-layout__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import StepIndicator from './StepIndicator.vue';
import BackLink from './BackLink.vue';

withDefaults(
  defineProps<{
    title: string;
    currentStep: number;
    totalSteps?: number;
    showBackLink?: boolean;
  }>(),
  {
    totalSteps: 4,
    showBackLink: true,
  },
);

const emit = defineEmits<{
  back: [];
}>();

const handleBack = () => {
  emit('back');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.step-layout {
  display: flex;
  flex-direction: column;
  padding: 16px;

  &__back-skip-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 10px 0;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: bold;
    color: $base-font-color;
    text-align: center;
    margin: 16px 0 24px;
    line-height: 1.4;
  }

  &__content {
    flex: 1;
  }

  &__footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
}
</style>
